import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppState, CoreComponentsModule, CoreModule } from '@app/core';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsModule } from '@ngxs/store';
import { NgxCaptchaModule } from 'ngx-captcha';
import { SharedModule } from 'shared';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent, ModulesContainerComponent } from './app.component';
import { MsalUserService } from './core/services/auth/msal-user.service';
import { ProgramasModule } from './modules/programas/programas.module';

declare global {
  interface Window {
    env: any;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    ModulesContainerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    CoreComponentsModule,
    CoreModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    NgxsModule.forRoot([AppState],
      { developmentMode: !environment.production }
    ),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production
    }),
    NgxsLoggerPluginModule.forRoot({
      disabled: true//environment.production
    }),
    ProgramasModule
  ],
  providers: [
    MsalUserService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor() {
    this.loadEnvironment();
  }

  loadEnvironment() {
    const env = window.env;
    if (env) {
      // No cambiar el entorno de producción aquí
      environment.baseUrlAPIDWH = env.API.baseUrlAPIDWH;
      environment.baseUrlAPIEXT = env.API.baseUrlAPIEXT;
      environment.urls.PORTAL_IMAGENES = env.API.PORTAL_IMAGENES;
      environment.microsoft.redirectUrl = env.API.redirectUrl;
      environment.anioCurso = env.anioCurso;
      environment.periodoCurso = env.periodoCurso;
    }
  }

}
